import { createContext } from "preact";
import { LegalClient } from "../../../client";

export const LegalClientContext = createContext(new LegalClient());
